module.exports = __webpack_public_path__ + "static/media/piper-celebrate.a683b85d.svg";